import { useState, useEffect } from 'react';
import { apiFetch } from '../api';

function CountdownTimers({ refreshKey }) {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [adding, setAdding] = useState(false);
  const [title, setTitle] = useState('');
  const [date, setDate] = useState('');

  useEffect(() => {
    fetchEvents();
  }, [refreshKey]);

  async function fetchEvents() {
    try {
      const res = await apiFetch('/api/countdown');
      if (res.ok) setEvents(await res.json());
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  async function addEvent(e) {
    e.preventDefault();
    if (!title.trim() || !date) return;
    try {
      const res = await apiFetch('/api/countdown', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ title: title.trim(), date }),
      });
      if (res.ok) setEvents(await res.json());
      setTitle('');
      setDate('');
      setAdding(false);
    } catch (err) {
      console.error(err);
    }
  }

  async function deleteEvent(id) {
    try {
      const res = await apiFetch(`/api/countdown/${id}`, { method: 'DELETE' });
      if (res.ok) setEvents(await res.json());
    } catch (err) {
      console.error(err);
    }
  }

  function getDaysUntil(dateStr) {
    const target = new Date(dateStr + 'T00:00:00');
    const now = new Date();
    now.setHours(0, 0, 0, 0);
    return Math.ceil((target - now) / (1000 * 60 * 60 * 24));
  }

  const sorted = [...events]
    .map((e) => ({ ...e, daysLeft: getDaysUntil(e.date) }))
    .sort((a, b) => a.daysLeft - b.daysLeft);

  return (
    <section className="card countdown-section">
      <div className="goals-header">
        <h2>Countdowns</h2>
        <button className="manage-btn" onClick={() => setAdding(!adding)}>
          {adding ? 'Cancel' : '+ Add'}
        </button>
      </div>
      {adding && (
        <form onSubmit={addEvent} className="countdown-form">
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Event name..."
            className="shopping-input"
            autoFocus
          />
          <input
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="shopping-input"
          />
          <button type="submit" className="submit-btn">Add</button>
        </form>
      )}
      {loading ? (
        <p className="loading">Loading...</p>
      ) : sorted.length === 0 ? (
        <p className="empty">No countdowns set</p>
      ) : (
        <div className="countdown-list">
          {sorted.map((event) => (
            <div key={event.id} className={`countdown-item${event.daysLeft < 0 ? ' past' : ''}`}>
              <div className="countdown-days">
                <span className="countdown-num">
                  {event.daysLeft === 0 ? 'Today!' : event.daysLeft > 0 ? event.daysLeft : Math.abs(event.daysLeft)}
                </span>
                {event.daysLeft !== 0 && (
                  <span className="countdown-label">
                    {event.daysLeft > 0 ? (event.daysLeft === 1 ? 'day' : 'days') : 'days ago'}
                  </span>
                )}
              </div>
              <div className="countdown-info">
                <span className="countdown-title">{event.title}</span>
                <span className="countdown-date">
                  {new Date(event.date + 'T00:00:00').toLocaleDateString('en-US', {
                    timeZone: 'America/Chicago',
                    month: 'short',
                    day: 'numeric',
                    year: 'numeric',
                  })}
                </span>
              </div>
              <button className="shopping-del" onClick={() => deleteEvent(event.id)}>&times;</button>
            </div>
          ))}
        </div>
      )}
    </section>
  );
}

export default CountdownTimers;
